import type { Input as SignalInput } from "@ebay/ebayui-core/dist/components/ebay-signal/index.d.marko";
import type { HotnessSignalText } from "../../@types/mapviewxs";
import type { HotnessSignalLevel } from "@ebay/experience-types-ebay";
export type SignalStatus = SignalInput["status"];
export interface Input {
  model?: HotnessSignalText;
}
export const STATUS_MAP: Record<HotnessSignalLevel, SignalStatus> = {
  NEUTRAL: "neutral",
  RECENCY: "recent",
  TIME_SENSITIVE: "time-sensitive",
  TRUSTWORTHY: "trustworthy",
};
$ const { model } = input;
$ const componentName = "hotness-signal";
$ const { text, level = "NEUTRAL" } = model || {};

<if(text)>
  <span class=componentName data-testid=componentName>
    <ebay-signal status=STATUS_MAP[level] title=text>
      ${text}
    </ebay-signal>
  </span>
</if>
